/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest from '../model/AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest';
import AllowedConnectionIpControllerDtoAllowedConnectionIpListRequest from '../model/AllowedConnectionIpControllerDtoAllowedConnectionIpListRequest';
import AllowedConnectionIpControllerDtoAllowedConnectionIpListResponse from '../model/AllowedConnectionIpControllerDtoAllowedConnectionIpListResponse';
import AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest from '../model/AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest';
import BaseResponse from '../model/BaseResponse';

/**
* AllowedConnectionIp service.
* @module api/AllowedConnectionIpApi
* @version 1.0
*/
export default class AllowedConnectionIpApi {

    /**
    * Constructs a new AllowedConnectionIpApi. 
    * @alias module:api/AllowedConnectionIpApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiAllowedConnectionIpAllowedConnectionIpCreatePost operation.
     * @callback module:api/AllowedConnectionIpApi~apiAllowedConnectionIpAllowedConnectionIpCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest} [allowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest] 
     * @param {module:api/AllowedConnectionIpApi~apiAllowedConnectionIpAllowedConnectionIpCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiAllowedConnectionIpAllowedConnectionIpCreatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['allowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/AllowedConnectionIp/AllowedConnectionIpCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiAllowedConnectionIpAllowedConnectionIpListPost operation.
     * @callback module:api/AllowedConnectionIpApi~apiAllowedConnectionIpAllowedConnectionIpListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpListRequest} [allowedConnectionIpControllerDtoAllowedConnectionIpListRequest] 
     * @param {module:api/AllowedConnectionIpApi~apiAllowedConnectionIpAllowedConnectionIpListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpListResponse}
     */
    apiAllowedConnectionIpAllowedConnectionIpListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['allowedConnectionIpControllerDtoAllowedConnectionIpListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = AllowedConnectionIpControllerDtoAllowedConnectionIpListResponse;
      return this.apiClient.callApi(
        '/api/AllowedConnectionIp/AllowedConnectionIpList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiAllowedConnectionIpAllowedConnectionIpRemovePost operation.
     * @callback module:api/AllowedConnectionIpApi~apiAllowedConnectionIpAllowedConnectionIpRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest} [allowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest] 
     * @param {module:api/AllowedConnectionIpApi~apiAllowedConnectionIpAllowedConnectionIpRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiAllowedConnectionIpAllowedConnectionIpRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['allowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/AllowedConnectionIp/AllowedConnectionIpRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
